import { GET_GHA_INFO_SUCCEEDED } from '../actions/actionTypes';
import GhaModel from '../../models/Gha';
import { GHA_SCHEMA } from '../../utils/gha';

const initialState: GhaModel = GHA_SCHEMA;

export const ghaInfoReducer = (state:GhaModel = initialState, action: any) => {
  switch (action.type) {
    case GET_GHA_INFO_SUCCEEDED:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        tariff: {... action.payload.tariff},
        info: {... action.payload.info},
        working_hours: {... action.payload.working_hours},
        dock_load: [... action.payload.dock_load],
        gha_fwd_config: {...action.payload.gha_fwd_config},
        airlines: [...action.payload.airlines],
        system_parameters: {...action.payload.system_parameters},
      }; 
    default:
      return state;
  }
};
